import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { useFieldControl } from "./Field.js";
import { useIsoLayoutEffect } from "./internal.js";
import { useMergedRefs } from "../internal/refs.js";
const Checkbox = React.forwardRef(function Checkbox2({ children, className, style, indeterminate = false, onChange, onCheckedChange, ...props }, ref) {
  const { disabled, ...rest } = useFieldControl(props);
  const inner = React.useRef(null);
  const mergedRef = useMergedRefs(ref, inner);
  useIsoLayoutEffect(() => {
    if (inner.current) inner.current.indeterminate = indeterminate;
  });
  const handleChange = (event) => {
    onChange?.(event);
    onCheckedChange?.(event.currentTarget.checked, event);
  };
  return /* @__PURE__ */ jsxs("label", { className: cx("ev-checkbox", className), style, "data-disabled": disabled ? "true" : void 0, children: [
    /* @__PURE__ */ jsx("input", { ref: mergedRef, className: "ev-check", disabled, onChange: handleChange, ...rest, type: "checkbox" }),
    children != null && children !== false ? /* @__PURE__ */ jsx("span", { className: "ev-checkbox__label", children }) : null
  ] });
});
Checkbox.displayName = "Checkbox";
export {
  Checkbox
};
//# sourceMappingURL=Checkbox.js.map
